import axios from 'axios';
import { Claim } from './claims';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export interface DraftEmailRequest {
  prompt: string;
  draftType?: 'email' | 'letter';
  claim?: Partial<Claim> | null;
  existingBody?: string;
  threadSummary?: string;
}

export interface DraftEmailResponse {
  success: boolean;
  draft: string;
  provider?: string;
  usage?: {
    prompt_tokens?: number;
    completion_tokens?: number;
    total_tokens?: number;
  };
}

export async function draftEmailWithAI(payload: DraftEmailRequest): Promise<DraftEmailResponse> {
  const response = await axios.post<DraftEmailResponse>(
    `${API_URL}/ui/ai/draft-email`,
    payload,
    { headers: getAuthHeaders(), timeout: 130000 }
  );
  return response.data;
}
